export function setCurrentBrackets(cursor, stringLines, allBrackets, membersMap) {

    const closestLineCol = (obj: Record<string, string>, line, col): string => {
        let result = '';

        for (const key in obj) {
            const [startLine, startCol] = key.split('.');
            const [endLine, endCol] = obj[key].split('.');

            if (Number(startLine) === line && Number(endLine) === line && Number(startCol) < col && Number(endCol) > col) {
                result = key;
            } else if (Number(startLine) === line && Number(endLine) !== line && Number(startCol) < col) {
                result = key;
            } else if (Number(startLine) === line && Number(startCol) === col) {
                result = key;
            } else if (Number(startLine) < line && Number(endLine) > line) {
                result = key;
            }

        }
        return result;
    };

    if (cursor) {
        const currentBrackets = [];
        const currentMemberHighlights = [];
        const line = cursor.line + 1;
        const col = cursor.ch;

        let colForBrackets = cursor.ch;
        let beforeBracket = null;
        let afterBracket = null;
        let brackets = null;
        let bracketsInStringsToHighlight = [];
        let templateLiteralOffset = 0;

        const stringsInCurLine = stringLines.filter(str => {
            return str.loc.start.line === line && str.loc.end.line === line;
        });

        const lineHasStrings = stringsInCurLine.length > 0;
        let strOffset = 0;
        if (lineHasStrings) {
            strOffset = stringsInCurLine[0].loc.start.column;
        }

        if (lineHasStrings) {
            let chars = [];
            if (stringsInCurLine[0].value) {
                chars = stringsInCurLine[0].value.split('');
            } else if (stringsInCurLine[0].quasis && stringsInCurLine[0].quasis.length > 0) {

                for (let i = 0; i < stringsInCurLine[0].quasis.length; i++) {
                    if (stringsInCurLine[0].quasis[i].loc.start.column < col &&
                        stringsInCurLine[0].quasis[i].loc.end.column > col) {
                        strOffset = 0;
                        colForBrackets = colForBrackets - stringsInCurLine[0].quasis[i].loc.start.column;
                        chars = stringsInCurLine[0].quasis[i].value.raw;
                        templateLiteralOffset = stringsInCurLine[0].quasis[i].loc.start.column - 1;
                        break;
                    }
                }

            }

            const bracketsArr = [];

            for (let i = 0; i < chars.length; i++) {
                if (chars[i] === '(') {
                    bracketsArr.push({
                        val: '(',
                        col: i + strOffset + 1 + templateLiteralOffset,
                        line,
                        highlight: (i + strOffset) < colForBrackets
                    });
                } else if (chars[i] === ')') {
                    const lastBr = bracketsArr.pop();
                    if (lastBr && lastBr.val === '(') {
                        if (i + strOffset + 2 > colForBrackets) {
                            bracketsInStringsToHighlight.push({
                                start: lastBr,
                                end: {
                                    val: ')',
                                    col: i + strOffset + 1 + templateLiteralOffset,
                                    line,
                                    highlight: lastBr.highlight
                                }
                            });
                        }
                    }
                }
            }

            bracketsInStringsToHighlight = bracketsInStringsToHighlight.filter(br => br.start.highlight && br.end.highlight);

            if (bracketsInStringsToHighlight.length > 0) {
                let highlightBrackets = false;
                for (let i = 0; i < bracketsInStringsToHighlight.length; i++) {
                    if (bracketsInStringsToHighlight[i].start.col <= col) {
                        highlightBrackets = true;
                        break;
                    }

                }
                if (!highlightBrackets) {
                    bracketsInStringsToHighlight = [];
                }
            }
        }

        if (!bracketsInStringsToHighlight.length) {
            if (allBrackets) {
                beforeBracket = allBrackets[`${line}.${col - 1}`];
                afterBracket = allBrackets[`${line}.${col}`];
                brackets = beforeBracket || afterBracket;

                if (closestLineCol(allBrackets, line, col)) {
                    currentBrackets.push(allBrackets[closestLineCol(allBrackets, line, col)]);
                    currentBrackets.push(allBrackets[allBrackets[closestLineCol(allBrackets, line, col)]]);
                }
            }
        }

        if (!brackets && allBrackets) {
            beforeBracket = allBrackets[`${line}.${col - 1}`];
            afterBracket = allBrackets[`${line}.${col}`];
            brackets = beforeBracket || afterBracket;
            if (brackets) {
                currentBrackets.push(brackets);
                currentBrackets.push(allBrackets[brackets]);
            }
        }

        if (membersMap) {
            Object.keys(membersMap)
                .map(key => {
                    if (parseInt(key.substring(0, key.indexOf('.'))) === line) { // filter by line
                        const [start, end] = key.split(':'); // filter by col
                        const [, startCol] = start.split('.');
                        const [, endCol] = end.split('.');
                        if (startCol <= col && endCol >= col) {
                            return {
                                key,
                                startCol,
                                endCol,
                                length: parseInt(endCol) - parseInt(startCol)
                            };
                        }
                        return null;
                    }
                    return null;
                })
                .filter(member => !!member)
                .sort((a, b) => a.length - b.length)
                .some(({ key, startCol, endCol }) => {
                    if (startCol <= col && endCol >= col) {
                        return currentMemberHighlights.push(membersMap[key]);
                    }
                    return false;
                });
        }

        return {
            bracketsInStringsToHighlight,
            currentBrackets,
            currentMemberHighlights,
        } ;
    }
}
